<div>
  @if (deviceSlot) {
    <div class="wm-deviceslot-summary wm-m-list-row" attr.data-testing-id="device_slot-summary-{{deviceSlot.id}}">
      <!-- first cell: the slot Logo and name -->
      <div class="wm-list-cell">
        <div class="wm-m-deviceslot-logo">
          @if (deviceSlot.isPublicSlot()) {
            <div class="logo-container" data-testing-id="public-slot"
              tooltipPosition="left" [pTooltip]="getSlotTypeTooltip()" [attr.data-slot-occupied]="deviceInSlot ? 'true' : 'false'">
              <img class="slot-base-logo" [src]="'assets/img/generic_mobile.svg'"/>
            </div>
          }
          @if (deviceSlot.isVCloudSlot() && deviceSlot.isWindowsSlot()) {
            <div class="logo-container" data-testing-id="windows-slot" [attr.data-slot-occupied]="deviceInSlot ? 'true' : 'false'"
              tooltipPosition="left" [pTooltip]="getSlotTypeTooltip()">
              <img class="slot-base-logo" [src]="'assets/img/generic_windows.svg'"/>
              @if (deviceSlot.isCustomSlot()) {
                <fa-icon (click)="toggleDeviceSlotDetails()" icon="info-circle" class="custom-slot"></fa-icon>
              }
            </div>
          }
          @if (deviceSlot.isVCloudSlot() && deviceSlot.isMacOSSlot()) {
            <div class="logo-container" data-testing-id="macos-slot" [attr.data-slot-occupied]="deviceInSlot ? 'true' : 'false'"
              tooltipPosition="left" [pTooltip]="getSlotTypeTooltip()">
              <img class="slot-base-logo" [src]="'assets/img/generic_macos.svg'"/>
              @if (deviceSlot.isCustomSlot()) {
                <fa-icon (click)="toggleDeviceSlotDetails()" icon="info-circle" class="custom-slot"></fa-icon>
              }
            </div>
          }
          <!-- TODO: check this in a more idiomatic way -->
          @if (deviceSlot.isVCloudSlot() && !deviceSlot.isMacOSSlot() && !deviceSlot.isWindowsSlot()) {
            <div class="logo-container" data-testing-id="vcloud-slot" tooltipPosition="left" [pTooltip]="getSlotTypeTooltip()" [attr.data-slot-occupied]="deviceInSlot ? 'true' : 'false'">
              <img class="slot-base-logo" [src]="'assets/img/generic_desktop.svg'"/>
              @if (deviceSlot.isCustomSlot()) {
                <fa-icon (click)="toggleDeviceSlotDetails()" size="sm" icon="info-circle" class="custom-slot"></fa-icon>
              }
            </div>
          }
          @if (advertisedDeployables !== undefined && advertisedDeployables.length > 0 && !deviceSlot.isPublicSlot() && !deviceSlot.isVCloudSlot()) {
            <div class="logo-container" data-testing-id="private-slot" tooltipPosition="left" [pTooltip]="getSlotTypeTooltip()" [attr.data-slot-occupied]="deviceInSlot ? 'true' : 'false'">
              @if (deployables !== undefined && deployables.length === 1 && hasAnnotations(deployables[0])) {
                <div class="maintenance-info" [ngClass]="getAnnotationStatus(deployables[0])">
                  <fa-icon icon="exclamation-triangle" [size]="'lg'" [pTooltip]="getAnnotationString(deployables[0])"></fa-icon>
                </div>
              }
              @if (deployables !== undefined && deployables.length === 1 && hasUserAnnotations(deployables[0])) {
                <div class="user-annotations">
                  <fa-icon icon="info-circle" [size]="'lg'" [pTooltip]="getUserAnnotationString(deployables[0])"></fa-icon>
                </div>
              }
              <img class="slot-base-logo" [src]="advertisedDeployables[0].logo"/>
              @if (advertisedDeployables.length > 1) {
                <fa-icon class="slot-more-devices" icon="plus" [fixedWidth]="true" aria-hidden="true"></fa-icon>
              }
              <!-- if there is only one mobile deployable in the slot, show platform logo alongside device-->
              @if (deployables !== undefined && deployables.length === 1) {
                <div class="logo-overlay-container" [pTooltip]="deployables[0].platform.getFullName()">
                  @if (deployables !== undefined && deployables.length === 1) {
                    <img class="logo-overlay" [src]="singleDeployableLogo"/>
                  }
                  @if (deployables !== undefined && deployables.length === 1 && deployables[0].platform.platformType==='Android') {
                    <div class="logo-background"></div>
                  }
                  @if (deployables !== undefined && deployables.length === 1) {
                    <div [ngClass]="{'logo-overlay-text-ios': deployables[0].platform.platformType==='iOS', 'logo-overlay-text-android': deployables[0].platform.platformType==='Android'}">{{clipVersionNumber(deployables[0].platform.platformVersion)}}</div>
                  }
                </div>
              }
            </div>
          }
          @if (advertisedDeployables !== undefined && advertisedDeployables.length === 0 && !deviceSlot.isPublicSlot() && !deviceSlot.isVCloudSlot()) {
            <div class="logo-container"
              tooltipPosition="left" [pTooltip]="getSlotTypeTooltip()" [attr.data-slot-occupied]="deviceInSlot ? 'true' : 'false'">
              <img class="slot-base-logo" [src]="'assets/img/generic_slot.svg'"/>
            </div>
          }
          @if (advertisedDeployables == undefined && !deviceSlot.isPublicSlot() && !deviceSlot.isVCloudSlot()) {
            <div class="logo-container">
              <p-progressSpinner [style]="{'width': '30px', 'height': '30px'}" class="wm-m-deviceslot-loading-spinner"></p-progressSpinner>
            </div>
          }
        </div>
        <!-- second cell: name and type -->
        <div class="wm-m-deviceslot-name-and-type">
          <div class="wm-m-deviceslot-name">{{deviceSlot.name}}</div>
          <div class="wm-m-deviceslot-type">
            {{getSlotTypeTooltip()}}
            @if (deployables.length === 1 && (deployables[0].platform.platformType === 'Android' || deployables[0].platform.platformType === 'iOS')) {
              &#64; {{deployables[0].platform.platformType}} {{clipVersionNumber(deployables[0].platform.platformVersion)}}
            }
          </div>
        </div>
      </div>
      <!-- fourth cell: slot information symbols -->
      @if (deviceSlot) {
        <div class="wm-m-deviceslot-status wm-list-cell">
          @if (deviceSlot.isAutoRedeployEnabledForProject(projectId)) {
            <fa-icon icon="history" size="lg" [pTooltip]="redeploymentTooltip" tooltipPosition="top"></fa-icon>
          }
          @if (shownReservation !== undefined && isReservedByMyself) {
            <fa-icon icon="lock" size="lg" [pTooltip]="'You currently have reserved yourself exclusive access to this slot '+shownReservation.toNiceString()" tooltipPosition="top"></fa-icon>
          }
          @if (shownReservation !== undefined && isReservedByAnotherUser && userHavingReservation !== undefined) {
            <fa-icon icon="ban" size="lg" [pTooltip]="'Reserved by ' + userHavingReservation.name + ' ' + shownReservation.toNiceString()" tooltipPosition="top"></fa-icon>
          }
          @if (shownReservation !== undefined && !isReservedByAnotherUser && !isReservedByMyself && userHavingReservation !== undefined) {
            <fa-icon icon="calendar-check" size="lg" attr.data-testing-id="device_slot-summary-{{deviceSlot.id}}-upcoming-reservation" [pTooltip]="'Next upcoming reservation was made by '+userHavingReservation.name+' '+shownReservation.toNiceString()" tooltipPosition="top"></fa-icon>
          }
          @if (deviceSlot.propertyBag?.updatePending === true) {
            <fa-icon icon="arrow-circle-up" size="lg" pTooltip="Update requested. Device is usable, but may go offline at any time when the update is applied." tooltipPosition="top" attr.data-testing-id="device_slot-summary-{{deviceSlot.id}}-update-pending"></fa-icon>
          }
        </div>
      }
      <!-- sixth and final cell: deployment and more -->
      @if (deviceSlot) {
        <div class="wm-m-deviceslot-actions wm-list-cell">
          @if (deviceSlot !== undefined && deviceSlot.availableForDeployment && deployables !== undefined) {
            <div class="wm-m-deviceslot-actions deploy-btn wm-list-cell"
              >
              @if (!userWantsToDeploy) {
                <span>
                  <div class="wm-deviceslot-toolbar-item match-deployed-device-text">
                    @if (!isReservedByAnotherUser) {
                      <button pButton class="p-button-text custom-label minimizable"
                        [disabled]="!userMayDeployDevices || devicesDefect() || !deployablesLoaded" (click)="deployDevice()"
                        tooltipPosition="top" [pTooltip]="tooltipForDeployButton()"
                        attr.data-testing-id="device_slot-summary-{{deviceSlot.id}}-deploybtn">
                        <fa-icon icon="upload" [fixedWidth]="true"></fa-icon> <span class="label">Deploy device</span>
                      </button>
                    }
                    @if (isReservedByAnotherUser && shownReservation !== undefined && userHavingReservation !== undefined) {
                      <button pButton class="p-button-text custom-label fake-disabled-button"
                        (click)="explainReservation()"
                        tooltipPosition="top" [pTooltip]="'Slot is reserved by ' + userHavingReservation.name + ' ' + shownReservation.toNiceString()">
                        <fa-icon icon="upload" [fixedWidth]="true"></fa-icon> <span class="label">Deploy device</span>
                      </button>
                    }
                    @if (isReservedByAnotherUser && (shownReservation == undefined || userHavingReservation == undefined)) {
                      <button pButton
                        class="p-button-text custom-label fake-disabled-button minimizable"
                        tooltipPosition="top" [pTooltip]="'Slot is reserved by another user.'">
                        <!-- does nothing, is disabled BUT avoids a unhandled case by the IFs above -->
                        <fa-icon icon="upload" [fixedWidth]="true"></fa-icon> <span class="wm-deviceslot-toolbar-item-label">Deploy device</span>
                      </button>
                    }
                  </div>
                </span>
              }
              @if (userWantsToDeploy) {
                <span>
                  <div class="wm-deviceslot-toolbar-item match-deployed-device-text ">
                    <button pButton class="p-button-text custom-label fake-disabled-button minimizable" [disabled]="!userMayDeployDevices || isReservedByAnotherUser"
                      ><fa-icon icon="sync-alt" animation="spin" [fixedWidth]="true"></fa-icon><span class="label">Deploy device</span></button>
                    </div>
                  </span>
                }
              </div>
            }
            @if (deviceSlot !== undefined && !deviceSlot.availableForDeployment) {
              <div class="wm-m-deviceslot-deployed-device wm-list-cell"
                [pTooltip]="userBlockingSlot ? ('A device created by ' + userBlockingSlot.name + ' blocks this slot' + (projectBlockingSlot ? ' in project ' + projectBlockingSlot.name : '')) : ('This device blocks this slot')"
                tooltipPosition="top">
                <div class="wm-m-deviceslot-deployed-device-icon">
                  <fa-icon icon="server" size="2x" [fixedWidth]="true" aria-hidden="true"></fa-icon>
                </div>
                @if (!deviceSlot.slotIsBeingReleased && !deviceInSlot) {
                  <div class="wm-m-deviceslot-deployed-device-text">
                    <div class="wm-m-deviceslot-deployed-device-info-upper-line">unknown device</div>
                    <div class="wm-m-deviceslot-deployed-device-info-lower-line">different project</div>
                  </div>
                }
                @if (!deviceSlot.slotIsBeingReleased && deviceInSlot && projectBlockingSlot) {
                  <div class="wm-m-deviceslot-deployed-device-text"
                    >
                    <div class="wm-m-deviceslot-deployed-device-info-upper-line">{{deviceInSlot.name}}</div>
                    @if (!deviceIsFromDifferentProject) {
                      <div class="wm-m-deviceslot-deployed-device-info-lower-line">in this
                        project
                      </div>
                    }
                    @if (deviceIsFromDifferentProject) {
                      <div class="wm-m-deviceslot-deployed-device-info-lower-line"
                      >{{projectBlockingSlot.name}}</div>
                    }
                  </div>
                }
                @if (deviceSlot.slotIsBeingReleased) {
                  <div class="wm-m-deviceslot-deployed-device-text">
                    <div class="wm-m-deviceslot-deployed-device-info-upper-line no-fat">Deleting device</div>
                    <div class="wm-m-deviceslot-deployed-device-info-lower-line">from slot</div>
                  </div>
                }
              </div>
            }
            @if (mayReserveSlot) {
              <div class="wm-deviceslot-toolbar-item">
                <button pButton class="p-button-text custom-label minimizable" (click)="openReservationTool()"
                  tooltipPosition="top" pTooltip="Reserve this device slot"
                  attr.data-testing-id="slot-{{deviceSlot.id}}-reserve-btn">
                  <fa-icon icon="calendar-plus" [fixedWidth]="true"></fa-icon>
                  <span class="label">Reserve Slot</span>
                </button>
              </div>
            }
            <div class="wm-deviceslot-toolbar-item wm-deviceslot-toolbar-item-last">
              <button #advancedOptionsButton pButton class="p-button-text minimizable" (click)="toggleAdvancedOptions($event, advancedOptions, advancedOptionsButton)" tooltipPosition="top" pTooltip="Advanced options" attr.data-testing-id="slot-{{deviceSlot.id}}-advancedoptbtn">
                <fa-icon icon="bars" [fixedWidth]="true"></fa-icon>
              </button>
            </div>
            <p-popover #advancedOptions appendTo="body" styleClass="device-advanced-options-popover" ariaLabel="Advanced slot options" [style]="{width: 'min(300px, calc(100vw - 32px))'}" (onShow)="alignAdvancedOptionsArrow(advancedOptions, advancedOptionsButton)" (onHide)="closeAdvancedOptions(advancedOptions)">
              <ng-template #content>
                <div class="wm-deviceslot-advanced-options">
                  <section class="wm-deviceslot-advanced-actions">
                    @for (action of advancedActions; track action.id) {
                      <button
                          type="button"
                          class="p-button p-component"
                          [class.p-button-secondary]="action.primary"
                          [class.wm-deviceslot-primary-action]="action.primary"
                          [class.p-button-text]="!action.primary"
                          [class.custom-label]="!action.primary"
                          [class.danger]="action.danger"
                          [disabled]="action.disabled"
                          [attr.data-testing-id]="action.id"
                          (click)="executeAdvancedAction(action, advancedOptions)">
                        <fa-icon [icon]="action.icon" [fixedWidth]="true" aria-hidden="true"></fa-icon>
                        <span>{{action.label}}</span>
                      </button>
                    }
                    @if (showDailyRedeploymentToggle) {
                      <div class="wm-deviceslot-setting-row">
                        <p-toggle-switch
                            [inputId]="'slot-daily-redeployment-' + deviceSlot.id"
                            [ngModel]="dailyRedeploymentEnabled"
                            [disabled]="dailyRedeploymentToggleDisabled"
                            aria-label="Toggle daily redeployment"
                            (onChange)="toggleAutoRedeploymentForSlot()"></p-toggle-switch>
                        <label [for]="'slot-daily-redeployment-' + deviceSlot.id">Daily redeployment</label>
                      </div>
                    }
                  </section>
                </div>
              </ng-template>
            </p-popover>
          </div>
        }
      </div>
    }

    @if (deviceSlot === undefined) {
      <div class="wm-deviceslot-summary wm-m-list-row">
        <div class="wm-m-deviceslot-logo wm-list-cell">
          <p-progressSpinner [style]="{'width': '48px', 'height': '48px'}" class="wm-m-deviceslot-loading-spinner"></p-progressSpinner>
        </div>
        <div class="wm-m-deviceslot-name-and-type wm-list-cell">
          <div class="wm-m-deviceslot-provider">Loading device slot</div>
        </div>
        <div class="wm-list-cell"><!--dummy col3--></div>
        <div class="wm-list-cell"><!--dummy col4--></div>
        <div class="wm-list-cell"><!--dummy col5--></div>
        <div class="wm-list-cell"><!--dummy col6--></div>
      </div>
    }

    @if (deviceSlot !== undefined && deviceSlotDetailsVisible) {
      <div class="wm-list-row wm-deviceslot-list-details">
        <div class="wm-deviceslot-list-details-close-arrow">
          <fa-icon icon="caret-up" size="2x" aria-hidden="true" (click)="toggleDeviceSlotDetails()" pTooltip="Close device details" tooltipPosition="right"></fa-icon>
        </div>
        <div class="wm-deviceslot-list-details-content">
          <div class="wm-deviceslot-list-details-table">
            <div class="wm-deviceslot-list-details-row">
              <div class="wm-deviceslot-list-details-entry row-desc">Technical identification:</div>
              @if (deviceSlot !== undefined) {
                <div class="wm-deviceslot-list-details-entry">DeviceSlot '{{deviceSlot.id}}'</div>
              }
            </div>
            @if (!deviceSlot.slotIsBeingReleased && userBlockingSlot && projectBlockingSlot) {
              <div class="wm-deviceslot-list-details-row">
                <div class="wm-deviceslot-list-details-entry row-desc">Currently blocked by:</div>
                @if (deviceInSlot === null) {
                  <div class="wm-deviceslot-list-details-entry">unknown device created by {{userBlockingSlot.name}} in a different project</div>
                }
                @if (!deviceIsFromDifferentProject && deviceInSlot) {
                  <div class="wm-deviceslot-list-details-entry">device {{deviceInSlot.name}} with identifier '{{deviceInSlot.id}}' deployed in this project, created by {{userBlockingSlot.name}}</div>
                }
                @if (deviceIsFromDifferentProject && deviceInSlot) {
                  <div class="wm-deviceslot-list-details-entry">device {{deviceInSlot.name}} with identifier '{{deviceInSlot.id}}' deployed in project '{{projectBlockingSlot.name}}', created by {{userBlockingSlot.name}} {{deviceInSlot.creationTime | wmCalendarFormat}}, last used {{deviceInSlot.lastUpdate | wmCalendarFormat}}</div>
                }
              </div>
            }
            <div class="wm-deviceslot-list-details-row">
              <div class="wm-deviceslot-list-details-entry row-desc">Daily/Continuous redeployment:</div>
              <div class="wm-deviceslot-list-details-entry">{{deviceSlot.isAutoRedeployEnabledForProject(projectId) ? 'any device inside this slot will be redeployed daily' : 'no automatic redeployment of devices inside this slot'}}</div>
            </div>
            @if (shownReservation !== undefined && (isReservedByMyself || isReservedByAnotherUser)) {
              <div class="wm-deviceslot-list-details-row">
                <div class="wm-deviceslot-list-details-entry row-desc">Currently reserved by:</div>
                @if (isReservedByMyself) {
                  <div class="wm-deviceslot-list-details-entry">You {{shownReservation.toNiceString()}}</div>
                }
                @if (isReservedByAnotherUser) {
                  <div class="wm-deviceslot-list-details-entry">{{userHavingReservation.name}} {{shownReservation.toNiceString()}}</div>
                }
              </div>
            }
            @if (mayReserveSlot) {
              @for (reservation of getUpcomingReservations(); track reservation; let isFirst = $first) {
                <div class="wm-deviceslot-list-details-row">
                  <div class="wm-deviceslot-list-details-entry row-desc">{{isFirst ? 'All upcoming reservations for this slot:' : ''}}</div>
                  <div class="wm-deviceslot-list-details-entry">{{getUserOfReservation(reservation.id)?.name }} {{reservation.toNiceString()}}</div>
                </div>
              }
            }
            @if (getPermanentIPInfo()) {
              <div class="wm-deviceslot-list-details-row">
                <div class="wm-deviceslot-list-details-entry row-desc">IP:</div>
                <div class="wm-deviceslot-list-details-entry">{{getPermanentIPInfo()}}</div>
              </div>
            }
            @if (getPermanentProxy()) {
              <div class="wm-deviceslot-list-details-row">
                <div class="wm-deviceslot-list-details-entry row-desc">Proxy:</div>
                <div class="wm-deviceslot-list-details-entry">{{getPermanentProxy().baseURL}} on port {{getPermanentProxy().proxyPort}} which is {{getPermanentProxy().permanent ? 'permanent' : 'non-permanent'}}</div>
              </div>
            }
            <!--              TODO: implement in some clever way     -->
            @if (deviceSlot.deviceRequirement !== undefined) {
              <div class="wm-deviceslot-list-details-row">
                <div class="wm-deviceslot-list-details-entry row-desc">Requirements for devices in this slot:</div>
                <div class="wm-deviceslot-list-details-entry">{{prettyPrintRequirements()}}</div>
              </div>
            }
            <!-- TODO: add more / all Permanent technical properties -->
          </div>
        </div>
      </div>
    }
  </div>
